<div class="flex-col gap-24 main-container h-100">
  <div class="h-100 w-100 map-container">
    <google-map
      [hidden]="!isMapReadySig()"
      [center]="mapsCoords()"
      mapId="cbb640a7be456708"
      [zoom]="16"
      #googleMap
      width="100%"
      height="100%"
    >
      <map-info-window>
        <div class="flex-row left-center gap-8" uiTruncateText>
          <span class="ui-icon-map-object"></span>
          <span>{{markerName()}}</span>
        </div>
      </map-info-window>
    </google-map>
  </div>
</div>
